require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./solutions-sales-performance.json") })
        }
      }, "path---solutions-sales-performance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---solutions-sales-performance!./.cache/json/solutions-sales-performance.json
// module id = 1494
// module chunks = 231608221292675